<mat-toolbar class="nk3-toolbar header bar" color="primary" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
        <app-logotype image="assets/images/k3-lightblue-512.png" alt="customerLanding.title"></app-logotype>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5em">
        <button
            class="search"
            mat-icon-button
            i18n-matTooltip="@@search"
            matTooltip="Search"
            (click)="onOpenSearch.emit(true)"
        >
            <mat-icon class="kd-icon-24">search</mat-icon>
        </button>
        <button class="search" mat-icon-button i18n-matTooltip="@@search" matTooltip="Search" (click)="openLink()">
            <mat-icon class="kd-icon-24">help_outline</mat-icon>
        </button>
        <button
            class="search"
            mat-icon-button
            i18n-matTooltip="@@login"
            matTooltip="Login"
            (click)="onLogin.emit(true)"
        >
            <mat-icon class="kd-icon-24">login</mat-icon>
        </button>

        <app-language-selector [globeDefault]="true"></app-language-selector>
    </div>
</mat-toolbar>
<!-- <app-main-search *ngIf="toggleSearch"></app-main-search> -->
